var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loading loading-lg mt-2"}):_c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.settings),function(item){return _c('general-item',{key:item.key,attrs:{"item":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }